import { PriceMode } from "../types";
import * as storage from "../helpers/storage";

const priceMode = (pm: PriceMode, price: number, fee: number, vatFactor: number): number => {
  switch (pm) {
    case "PRIVATE/SHOW_FEE":
    case "PRIVATE/SPECIFIED_FEE":
    case "PRICE_MODE_DEFAULT":
      return Math.round(price + fee);
    case "BUSINESS/SHOW_FEE":
    case "BUSINESS/SPECIFIED_FEE":
    case "PRICE_MODE_EXCLUDE_VAT":
      return Math.round(((price + fee) * 10000) / (10000 + vatFactor));
    case "PRIVATE/NO_FEE":
    case "PRICE_MODE_EXCLUDE_FEE":
      return Math.round(price);
    case "BUSINESS/NO_FEE":
    case "PRICE_MODE_EXCLUDE_FEE_AND_VAT":
      return Math.round((price * 10000) / (10000 + vatFactor));
    default:
      return Math.round(price + fee);
  }
};

export const getCustomer = (pm: PriceMode): "PRIVATE" | "BUSINESS" => {
  switch (pm) {
    case "PRICE_MODE_DEFAULT":
    case "PRICE_MODE_EXCLUDE_FEE":
      return "PRIVATE";
    case "PRICE_MODE_EXCLUDE_VAT":
    case "PRICE_MODE_EXCLUDE_FEE_AND_VAT":
      return "BUSINESS";
    default:
      return pm.split("/")[0] as "PRIVATE" | "BUSINESS";
  }
};

export const convertPriceMode = (pm: PriceMode): PriceMode => {
  switch (pm) {
    case "PRICE_MODE_DEFAULT":
      return "PRIVATE/SHOW_FEE";
    case "PRICE_MODE_EXCLUDE_VAT":
      return "BUSINESS/SHOW_FEE";
    case "PRICE_MODE_EXCLUDE_FEE":
      return "PRIVATE/NO_FEE";
    case "PRICE_MODE_EXCLUDE_FEE_AND_VAT":
      return "BUSINESS/NO_FEE";
    default:
      return pm;
  }
};

export const newPriceMode = (
  pm: PriceMode,
  price: number,
  fee: number,
  vatFactor: number,
): { price: number; fee: number } => {
  const customer = storage.getItem("customer_type", getCustomer(pm));
  let totalPrice = 0;
  let totalFee = 0;
  const cpm = convertPriceMode(pm);
  if (cpm.includes("SHOW_FEE")) {
    totalPrice = price + fee;
  } else if (cpm.includes("SPECIFIED_FEE")) {
    totalPrice = price;
    totalFee = fee;
  } else {
    totalPrice = price;
  }
  if (customer === "BUSINESS") {
    return {
      price: Math.round((totalPrice * 10000) / (10000 + vatFactor)),
      fee: Math.round((totalFee * 10000) / (10000 + vatFactor)),
    };
  } else {
    return { price: totalPrice, fee: totalFee };
  }
};

export default priceMode;
